import React, { useEffect } from 'react';
import AnimalWelfare from './pages/AnimalWelfare';
import './App.css';

function App() {
  useEffect(() => {
    // Set page title
    document.title = 'Voices for Animal Welfare Uganda';
  }, []);

  return (
    <div className="App">
      <AnimalWelfare />
    </div>
  );
}

export default App;